import { toast } from '@/components/toast';
import { getTranslationGroups, GetTranslationGroupsRes } from '@/services/api';
import { logger } from '@/services/logger';
import { useInfiniteQuery } from 'react-query';
import { GET_TRANSLATION_GROUPS_KEY } from './translationLibrary';
import { useAddLoadingTranslationGroups } from './useAddLoadingTranslationGroups';

const FIVE_MINUTES = 1000 * 60 * 5;

export const useGetTranslationGroups = (isAnonymous?: boolean) => {
    const { addLoadingGroups } = useAddLoadingTranslationGroups();

    const query = useInfiniteQuery<GetTranslationGroupsRes>(
        GET_TRANSLATION_GROUPS_KEY,
        ({ pageParam: token }) => {
            if (isAnonymous) {
                return { groups: [] };
            }

            return getTranslationGroups(token);
        },
        {
            staleTime: FIVE_MINUTES,
            refetchOnWindowFocus: false,
            keepPreviousData: true,
            getNextPageParam: ({ token }) => token,
            onError: err => {
                logger.error('Could not fetch translations', { err });
                toast.error({ title: 'Could not fetch translations', toastId: `${GET_TRANSLATION_GROUPS_KEY}-error` });
            },
            select: data => ({
                ...data,
                pages: data.pages.map((page, idx) => ({
                    ...page,
                    groups:
                        idx === 0
                            ? addLoadingGroups(page.groups.filter(({ persist }) => !!persist))
                            : page.groups.filter(({ persist }) => !!persist),
                })),
            }),
        }
    );

    const groups = query.data?.pages.flatMap(page => page.groups) ?? [];

    return { ...query, data: { groups } };
};
